const root = process.env.REACT_APP_API_GRAPHQL;
const bannerRoute =
  root +
  "?query={aCBannerBackground{bG4KDesktopIpadLandscape{urls} bGIpadPortrait{urls} bGMobile{urls}} aCBannerButtonConsultarImage{botonConsultar{urls} url{url text}} aCBannerButtonWhatsappImage{whatsappLogo{urls} url{url}} aCBannerMainImage{mainImage{urls} mainImage2x{urls} mainImage3x{urls}} aCBannerText{linea1{html} linea2{html} linea3{html} linea4{html} linea5{html}}}";

export default bannerRoute;